export default "images/组 15.png";